import React, { useState } from 'react';
import { FaShieldAlt, FaCheckCircle } from 'react-icons/fa';
import { SectionCard, Field, TextInput, Select, SaveRow, palette } from './ui';
import { ID_TYPES } from './constants';

export default function IdVerificationCard({ isDarkMode, profile, onSave }) {
  const c = palette(isDarkMode);
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ id_type: '', id_last4: '' });

  const startEdit = () => {
    setForm({ id_type: profile.id_type || '', id_last4: profile.id_last4 || '' });
    setEditing(true);
  };

  const save = async () => {
    if (!form.id_type || form.id_last4.length !== 4) return;
    setSaving(true);
    const ok = await onSave(form);
    setSaving(false);
    if (ok) setEditing(false);
  };

  const typeLabel = (ID_TYPES.find(t => t.value === profile.id_type) || {}).label;

  return (
    <SectionCard
      id="identity"
      title="ID verification"
      subtitle="Builds trust with employers. We only store the last 4 digits — never your full ID number."
      isDarkMode={isDarkMode}
      onEdit={startEdit}
      editing={editing}
    >
      {!editing ? (
        profile.id_type ? (
          <div className="flex items-center gap-3">
            <FaShieldAlt className={`h-5 w-5 ${c.secondaryText}`} />
            <p className={`text-sm ${c.text}`}>
              {typeLabel} ending in <span className="font-mono">••••{profile.id_last4}</span>
            </p>
            {profile.id_verified && (
              <span className="flex items-center gap-1 text-sm text-green-500 font-medium">
                <FaCheckCircle className="h-4 w-4" /> Verified
              </span>
            )}
          </div>
        ) : (
          <p className={`text-sm italic ${c.secondaryText}`}>
            Add an ID like Aadhaar or Voter ID to show employers you are a real person.
          </p>
        )
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Field label="ID type *">
            <Select isDarkMode={isDarkMode} value={form.id_type} onChange={e => setForm(f => ({ ...f, id_type: e.target.value }))} options={ID_TYPES} placeholder="Select ID" />
          </Field>
          <Field label="Last 4 digits *">
            <TextInput
              isDarkMode={isDarkMode}
              inputMode="numeric"
              maxLength={4}
              value={form.id_last4}
              onChange={e => setForm(f => ({ ...f, id_last4: e.target.value.replace(/\D/g, '').slice(0, 4) }))}
              placeholder="e.g. 1234"
            />
          </Field>
          <div className="sm:col-span-2">
            <SaveRow isDarkMode={isDarkMode} onSave={save} onCancel={() => setEditing(false)} saving={saving} />
          </div>
        </div>
      )}
    </SectionCard>
  );
}
